import React from 'react';
import PropTypes from 'prop-types';

import AutoGenerateGroupInner from './AutoGenerateGroupInner';
import Dialog from '../../../common/Dialog';

const AutoGenerateGroupDialog = ({ open, onClose, generating, onGenerate }) => (
  <Dialog id="auto-generate-group" open={open} onClose={onClose}>
    <AutoGenerateGroupInner
      onClose={onClose}
      generating={generating}
      onGenerate={onGenerate}
    />
  </Dialog>
);

AutoGenerateGroupDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  generating: PropTypes.bool.isRequired,
  onGenerate: PropTypes.func.isRequired,
};

export default AutoGenerateGroupDialog;
